



















import { Component, Vue, Prop, Provide, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import Loader from "@/components/Loader.vue";
import TemplateTable from "@/components/contentset/manager/TemplateTable.vue";
import ContentConfiguration from "@/components/contentset/manager/ContentConfiguration.vue";
import StopTest from "@/components/contentset/manager/StopTest.vue";
import { ContentSetVersionModel } from "../../../models/content/content-set-version.model";
import { IContentSetVersion } from "../../../models/interfaces/content/content-set-version.model.interface";
import { IContentSetPerformance } from "../../../models/interfaces/content/content-set-performance.model.interface";

const ContentSetVersionModule = namespace("contentSetVersionModule");
const ContentSetModule = namespace("contentSetModule");

@Component({
  components: {
    Loader,
    TemplateTable,
    ContentConfiguration,
    StopTest
  }
})
export default class LiveContent extends Vue {
  @ContentSetVersionModule.Action public retrieveLiveVersion;
  @ContentSetVersionModule.Getter public live;
  @ContentSetModule.Getter public contentSet;

  get getContentSetVersionModel(): IContentSetVersion {
    return this.live;
  }

  private loading: boolean = true;

  private contentSetVersion: IContentSetVersion = new ContentSetVersionModel();

  @Watch("content", { deep: true })
  public onContentSetUpdate() {
    this.getLiveContentSetVersion();
  }

  @Watch("getContentSetVersionModel.contentSetVersionId")
  public onLiveUpdate() {
    this.contentSetVersion = this.getContentSetVersionModel;
  }

  @Watch("getContentSetVersionModel.templates.0.enquiry.templateId")
  public onEnquiryUpdate() {
    this.contentSetVersion = this.getContentSetVersionModel;
  }

  @Watch("getContentSetVersionModel.templates.0.performance.id")
  public onPerformanceUpdate() {
    this.contentSetVersion = this.getContentSetVersionModel;
  }

  public created() {
    this.getLiveContentSetVersion();
  }

  private getLiveContentSetVersion() {
    this.loading = true;
    this.retrieveLiveVersion().then((result) => {
      this.loading = false;
      if (this.getContentSetVersionModel) {
        this.contentSetVersion = this.getContentSetVersionModel;
      }
    });
  }
}
